// import { BiltyFormat1, BiltyFormat2, BiltyFormat3 } from "BiltyFomates";
// import { getBuiltyPrint, getMasterData } from "_services";
// import { CommonModal, CustomSelect } from "components";
// import { UserContext } from "context";
// import { API, AppConfig } from "lib";
// import React, { useContext, useEffect, useRef, useState } from "react";
// import moment from "moment";
// import StorageService from "utils/StorageServices/StorageServices";
// import Loading from "pages/Loading";
// import { Images } from "constants";
// import { StorageServices } from "utils";
// import { getAllLrFormatebyBranch } from "_services/accountsServices/branchServices";
// import AddLrFormatModal from "modals/AddLrFormatModal";


// const BiltyPrintModal = (props) => {
//     const { freightId, tripDetais } = props;
//     const [loading, setLoading] = useState(false);
//     const [loadingBilty, setLoadingBilty] = useState(false)
//     let isToken = localStorage.getItem("token");
//     const [state, setState] = useState({
//         formate: "",
//         page: "",
//     });
//     const [builtyFormatList, setBuiltyFormatList] = useState([])
//     const [buityFormatePreview, setBuityFormatePreview] = useState('')
//     const [isLoaddingPrint, setIsLoaddingPrint] = useState(false)
//     const companyId = StorageServices.getCompanyId()
//     const branchID = tripDetais?.branch_id?._id
//     const [pageofPint, setPageOfPrint] = useState([])
//     const [formatDetails, setFormatDetails] = useState('')
//     const [pageDetails, setPageDetails] = useState('')
//     const [showAddNewFormat, setShowAddNewFormat] = useState(false)
//     const [isSelected, setIsSelected] = useState([])

//     const hasSetDefaultRef = useRef(null)


//     useEffect(() => {
//         if (formatDetails) {
//             const checkedCopies = formatDetails.copies
//                 .filter((c) => c?.check === true)
//                 .map((c) => ({
//                     ...c,
//                     label: c.name,
//                 }));

//             setPageOfPrint(checkedCopies)
//             setPageDetails(checkedCopies[0]?.value)
//         }
//     }, [formatDetails])

//     useEffect(() => {
//         if (pageDetails) {
//             getBuiltyPrintapi(formatDetails, pageDetails)
//         }

//     }, [pageDetails, formatDetails])

//     useEffect(() => {
//         if (companyId && branchID) {
//             getBranchLrFormat(companyId, branchID)
//         }
//     }, [companyId, branchID])

//     const getBranchLrFormat = async (company_id, branch_id) => {
//         const payload = { company_id, branch_id };

//         try {
//             const res = await getAllLrFormatebyBranch(payload);

//             if (res?.responseCode === 200) {

//                 const formats = res?.data?.formats || [];

//                 if (formats.length <= 0) {

//                     props?.closeModal()
//                     props?.confirmBox()
//                     return;
//                 }

//                 const formattedList = formats.map((i) => ({
//                     ...i,
//                     label: i?.name,
//                     value: i?.id,
//                 }));

//                 setBuiltyFormatList(formattedList);
//                 const defaultFormat = formats.find(f => f.is_default === 1);
//                 // const defaultFormat = formats[0];
//                 if (defaultFormat) {

//                     setFormatDetails(defaultFormat)
//                 }
//             }
//         } catch (error) {
//             console.error("Error in getBranchLrFormat:", error);
//         }
//     };


//     const getBuiltyPrintapi = async (formatDetails, pageDetails) => {

//         setLoadingBilty(true)
//         try {

//             const formate = {
//                 formate: formatDetails?.id,
//                 page: pageDetails
//             }

//             const res = await getBuiltyPrint({
//                 formate,
//                 company_id: StorageService?.getCompanyId(),
//                 trip_id: freightId
//             });

//             setBuityFormatePreview(res)

//             if (res) {
//                 setLoadingBilty(false)
//             }

//         } catch (error) {
//         }
//     };




//     const handlePrintDownload = async () => {
//         const url = `${AppConfig.api_baseurl}${API.GET_BUILTY2}/${formatDetails?.id}/${StorageService?.getCompanyId()}/${freightId}?no_of_pages=${pageDetails}`;

//         try {
//             setLoading(true);

//             const response = await fetch(url, {
//                 headers: {
//                     'Token': `${isToken}`,// if needed
//                 },
//             });

//             const blob = await response.blob();
//             const blobURL = URL.createObjectURL(blob);

//             const iframe = document.createElement('iframe');
//             iframe.style.display = 'none';
//             iframe.src = blobURL;

//             iframe.onload = function () {
//                 setTimeout(() => {
//                     iframe.contentWindow?.focus();
//                     iframe.contentWindow?.print();
//                 }, 300);
//             };

//             document.body.appendChild(iframe);
//             setLoading(false);
//         } catch (error) {
//             console.error('Print download failed:', error);
//             setLoading(false);
//         }
//     };

//     const handleDownload = async () => {
//         try {
//             const payload = {
//                 invoice_format: formatDetails.id,
//                 no_of_pages: pageDetails,
//                 company_id: StorageService?.getCompanyId(),
//                 trip_id: freightId
//             }
//             setIsLoaddingPrint(true)
//             const response = await fetch(`${AppConfig.api_baseurl}${API.BUILY_DOWNLOAD2}`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Token': `${isToken}`,
//                 },
//                 body: JSON.stringify(payload)
//             });

//             if (!response.ok) {
//                 throw new Error('Network response was not ok');
//             }

//             const blob = await response.blob();
//             const url = window.URL.createObjectURL(blob);
//             const a = document.createElement('a');
//             a.href = url;
//             a.download = `Format-${state?.formate}/${moment(new Date()).format("D MMM YYYY")}.pdf`;
//             document.body.appendChild(a);
//             a.click();
//             a.remove();
//             setIsLoaddingPrint(false)
//         } catch (error) {
//             setIsLoaddingPrint(false)
//         }
//     }

//     const formatePrpsTrip = {
//         buityFormatePreview: buityFormatePreview
//     };



//     const propsBuiltyPrint = {
//         ...props,
//         // onSubmit:handlePrint
//         onPrint: handleDownload,
//         onSubmit: handlePrintDownload,
//         isLoadding: loading,
//         disabled: loading || loadingBilty || isLoaddingPrint,
//         isLoaddingPrint: isLoaddingPrint
//     };



//     return (
//         <>
//             <CommonModal {...propsBuiltyPrint}>
//                 <div className="bltyPrint_body">
//                     <div className="bltyPrt_viewPage_bx" id="print-area">

//                         {!loadingBilty ? <BiltyFormat3 {...formatePrpsTrip} /> : <div colSpan="100%" style={{ textAlign: "center", margin: "0 22rem", display: "flex", alignItems: "center", justifyContent: "center", height: "50vh" }}>
//                             <img className="_loadWidth" style={{ width: "150px", color: "f2f2f2" }} src={Images.LOADINGTRUCK} alt="" />
//                         </div>}
//                     </div>

//                     <div className="_prtRight_selctors">
//                         <div>
//                             <CustomSelect
//                                 label="Bilty Format"
//                                 options={builtyFormatList}
//                                 value={builtyFormatList?.find((i) => i?.value === formatDetails?.id)}
//                                 onSelect={(data) =>
//                                     setFormatDetails(data)
//                                 }
//                                 isAddButton={true}
//                                 addButtonAction={() => { setShowAddNewFormat(true) }}
//                             />
//                         </div>

//                         <div>
//                             <CustomSelect
//                                 label="Number of Pages"
//                                 options={pageofPint}
//                                 value={pageofPint?.find((i) => i?.value === pageDetails)}
//                                 onSelect={(data) => setPageDetails(data?.value)}
//                             />
//                         </div>
//                     </div>
//                 </div>

//                 {showAddNewFormat && <AddLrFormatModal
//                     show={showAddNewFormat}
//                     onClose={() => setShowAddNewFormat(false)}
//                     companyId={companyId}
//                     branchId={branchID}
//                     addedFormats={isSelected}
//                     onFormatAdded={(updatedFormats) => {
//                         setIsSelected(updatedFormats);

//                         // Agar pehla format add hua to default set karo
//                         if (updatedFormats.length === 1) {
//                             hasSetDefaultRef.current = true;
//                             changeDefaultStatus(1, updatedFormats[0]?._id);
//                         }

//                         getBranchLrFormat(companyId, branchID);
//                     }}
//                 />}
//             </CommonModal>


//         </>
//     );
// };

// export default BiltyPrintModal;


import { BiltyFormat1, BiltyFormat2, BiltyFormat3 } from "BiltyFomates";
import { getBuiltyPrint, getMasterData } from "_services";
import { CommonModal, CustomSelect } from "components";
import { UserContext } from "context";
import { API, AppConfig } from "lib";
import React, { useContext, useEffect, useRef, useState } from "react";
import moment from "moment";
import StorageService from "utils/StorageServices/StorageServices";
import Loading from "pages/Loading";
import { Images } from "constants";
import { StorageServices } from "utils";
import { getAllLrFormatebyBranch, changeDefaultStatusApi } from "_services/accountsServices/branchServices";
import AddLrFormatModal from "modals/AddLrFormatModal";
import toast from "react-hot-toast";
import LrSettingOffcanvas from "modals/LrSettingOffcanvas";


const BiltyPrintModal = (props) => {
    const { freightId, tripDetais } = props;
    const [loading, setLoading] = useState(false);
    const [loadingBilty, setLoadingBilty] = useState(false);
    let isToken = localStorage.getItem("token");
    const [state, setState] = useState({ formate: "", page: "" });
    const [builtyFormatList, setBuiltyFormatList] = useState([]);
    const [buityFormatePreview, setBuityFormatePreview] = useState('');
    const [isLoaddingPrint, setIsLoaddingPrint] = useState(false);
    const companyId = StorageServices.getCompanyId();
    const branchID = tripDetais?.branch_id?._id;
    const [pageofPint, setPageOfPrint] = useState([]);
    const [formatDetails, setFormatDetails] = useState('');
    const [pageDetails, setPageDetails] = useState('');
    const [showAddNewFormat, setShowAddNewFormat] = useState(false);
    const [form, setForm] = useState("")
    // ✅ isSelected: branch me already added formats track karne ke liye
    const [isSelected, setIsSelected] = useState([]);
    const [showLrSetting, setShowLrSetting] = useState(false)
    const hasSetDefaultRef = useRef(false);

    // ─────────────────────────────────────────
    // Copies se pages list banana
    // ─────────────────────────────────────────
    useEffect(() => {
        if (formatDetails) {
            const checkedCopies = formatDetails.copies
                .filter((c) => c?.check === true)
                .map((c) => ({ ...c, label: c.name }));

            setPageOfPrint(checkedCopies);
            setPageDetails(checkedCopies[0]?.value);
        }
    }, [formatDetails]);

    // ─────────────────────────────────────────
    // Page/format change hone par print preview
    // ─────────────────────────────────────────
    useEffect(() => {
        if (pageDetails) {
            getBuiltyPrintapi(formatDetails, pageDetails);
        }
    }, [pageDetails, formatDetails]);

    // ─────────────────────────────────────────
    // On mount: branch ke formats fetch karo
    // ─────────────────────────────────────────
    useEffect(() => {
        if (companyId && branchID) {
            getBranchLrFormat(companyId, branchID);
        }
    }, [companyId, branchID]);

    // ─────────────────────────────────────────
    // hasSetDefaultRef wala effect (BranchLrFormat jaisa)
    // ─────────────────────────────────────────
    useEffect(() => {
        if (hasSetDefaultRef.current && isSelected.length === 1) {
            hasSetDefaultRef.current = false;
            changeDefaultStatus(1, isSelected[0]?._id);
        }
    }, [isSelected]);

    // ─────────────────────────────────────────
    // Branch ke LR formats fetch
    // ─────────────────────────────────────────
    const getBranchLrFormat = async (company_id, branch_id) => {
        const payload = { company_id, branch_id };
        try {
            const res = await getAllLrFormatebyBranch(payload);
            if (res?.responseCode === 200) {
                const formats = res?.data?.formats || [];

                if (formats.length <= 0) {
                    props?.closeModal();
                    props?.confirmBox();
                    return;
                }

                // ✅ isSelected update karo taaki AddLrFormatModal ko pata rahe kya already added hai
                setIsSelected(formats);

                const formattedList = formats.map((i) => ({
                    ...i,
                    label: i?.name,
                    value: i?.id,
                }));
                setBuiltyFormatList(formattedList);

                const defaultFormat = formats.find((f) => f.is_default === 1);
                if (defaultFormat) {
                    setFormatDetails(defaultFormat);
                }
            }
        } catch (error) {
            console.error("Error in getBranchLrFormat:", error);
        }
    };

    // ─────────────────────────────────────────
    // ✅ changeDefaultStatus — BranchLrFormat se copy kiya
    // ─────────────────────────────────────────
    const changeDefaultStatus = async (checkedValue, formatId) => {
        const payload = {
            company_id: companyId,
            branch_id: branchID,
            format_id: formatId,
            is_default: checkedValue,
        };
        try {
            const res = await changeDefaultStatusApi(payload);
            if (res?.responseCode !== 200) {
                toast.error(res?.responseMessage || "Failed to update default status.");
            }
        } catch (error) {
            toast.error(error?.message || "Something went wrong.");
        } finally {
            getBranchLrFormat(companyId, branchID);
            setShowAddNewFormat(false)
        }
    };

    // ─────────────────────────────────────────
    // Preview API
    // ─────────────────────────────────────────
    const getBuiltyPrintapi = async (formatDetails, pageDetails) => {
        setLoadingBilty(true);
        try {
            const res = await getBuiltyPrint({
                formate: { formate: formatDetails?.id, page: pageDetails },
                company_id: StorageService?.getCompanyId(),
                trip_id: freightId,
            });
            setBuityFormatePreview(res);
        } catch (error) {
            console.error("getBuiltyPrintapi error:", error);
        } finally {
            setLoadingBilty(false);
        }
    };

    // ─────────────────────────────────────────
    // Print
    // ─────────────────────────────────────────
    const handlePrintDownload = async () => {
        const url = `${AppConfig.api_baseurl}${API.GET_BUILTY2}/${formatDetails?.id}/${StorageService?.getCompanyId()}/${freightId}?no_of_pages=${pageDetails}`;
        try {
            setLoading(true);
            const response = await fetch(url, { headers: { Token: `${isToken}` } });
            const blob = await response.blob();
            const blobURL = URL.createObjectURL(blob);

            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = blobURL;
            iframe.onload = () => {
                setTimeout(() => {
                    iframe.contentWindow?.focus();
                    iframe.contentWindow?.print();
                }, 300);
            };
            document.body.appendChild(iframe);
        } catch (error) {
            console.error('Print download failed:', error);
        } finally {
            setLoading(false);
        }
    };

    // ─────────────────────────────────────────
    // Download
    // ─────────────────────────────────────────
    const handleDownload = async () => {
        try {
            setIsLoaddingPrint(true);
            const payload = {
                invoice_format: formatDetails.id,
                no_of_pages: pageDetails,
                company_id: StorageService?.getCompanyId(),
                trip_id: freightId,
            };
            const response = await fetch(`${AppConfig.api_baseurl}${API.BUILY_DOWNLOAD2}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Token: `${isToken}` },
                body: JSON.stringify(payload),
            });
            if (!response.ok) throw new Error('Network response was not ok');

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Format-${state?.formate}/${moment(new Date()).format("D MMM YYYY")}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();
        } catch (error) {
            console.error("Download error:", error);
        } finally {
            setIsLoaddingPrint(false);
        }
    };

    // ─────────────────────────────────────────
    // Modal props
    // ─────────────────────────────────────────
    const propsBuiltyPrint = {
        ...props,
        onPrint: handleDownload,
        onSubmit: handlePrintDownload,
        isLoadding: loading,
        disabled: loading || loadingBilty || isLoaddingPrint,
        isLoaddingPrint,
    };

    return (
        <>
            <CommonModal {...propsBuiltyPrint}>
                <div className="bltyPrint_body">
                    <div className="bltyPrt_viewPage_bx" id="print-area">
                        {!loadingBilty
                            ? <BiltyFormat3 buityFormatePreview={buityFormatePreview} />
                            : (
                                <div style={{ textAlign: "center", margin: "0 22rem", display: "flex", alignItems: "center", justifyContent: "center", height: "50vh" }}>
                                    <img className="_loadWidth" style={{ width: "150px" }} src={Images.LOADINGTRUCK} alt="" />
                                </div>
                            )
                        }
                    </div>

                    <div className="_prtRight_selctors">
                        <div>
                            <CustomSelect
                                label="Bilty Format"
                                options={builtyFormatList}
                                value={builtyFormatList?.find((i) => i?.value === formatDetails?.id)}
                                onSelect={(data) => setFormatDetails(data)}
                                isAddButton={true}
                                addButtonAction={() => setShowAddNewFormat(true)}
                                onEditValue={(data) => {

                                  setShowLrSetting(data)
                                  setForm(data)
                                }}
                            />
                        </div>

                        <div>
                            <CustomSelect
                                label="Number of Pages"
                                options={pageofPint}
                                value={pageofPint?.find((i) => i?.value === pageDetails)}
                                onSelect={(data) => setPageDetails(data?.value)}
                            />
                        </div>
                    </div>
                </div>

                {/* ✅ AddLrFormatModal — sahi props ke saath */}
                {showAddNewFormat && (
                    <AddLrFormatModal
                        show={showAddNewFormat}
                        onClose={() => setShowAddNewFormat(false)}
                        companyId={companyId}
                        branchId={branchID}
                        addedFormats={isSelected}
                        onFormatAdded={({ localAdded, frWithoutImage }) => {
                            setIsSelected(localAdded);
                            changeDefaultStatus(1, frWithoutImage?._id);
                        }}
                    />
                )}

                {showLrSetting && <LrSettingOffcanvas
                    show={showLrSetting}
                    onClose={() => setShowLrSetting(false)}
                    form={form}
                    setForm={setForm}
                    companyId={companyId}
                    branchId={branchID}
                    onUpdateSuccess={() => getBranchLrFormat(companyId, branchID)}
                />}
            </CommonModal>
        </>
    );
};

export default BiltyPrintModal;